// Ebeveyn uygulamasında Pano menüsü, Türkçe (bkz. boardViewApp.nl.ts).
export const appBoardViewTr = {
    title: 'Pano',
    intro: 'Pano şu anda böyle görünüyor, canlı. Yalnızca izleme: dokunmak panonun kendisinde.',
    choose: 'Pano',
    lastSeen: 'Son görülme {when}',
    neverSeen: 'Henüz görülmedi',
    virtual: 'Sanal iPad',
    viewOnly: 'Yalnızca izleme',
    loading: 'Pano yükleniyor…',
    reconnecting: 'Yeniden bağlanıyor…',
    revoked: 'Bu panonun bağlantısı kaldırıldı.',
    failed: 'Pano gösterilemedi.',
    retry: 'Tekrar dene',
    frameTitle: 'Pano {name}, yalnızca izleme',
    parentsOnly: 'Panoyu burada yalnızca ebeveynler görebilir.',
    emptyTitle: 'Henüz pano yok',
    emptyText: 'Bir tablet bağla, panoyu burada görürsün.',
    emptyLink: 'Tablet bağla',
};
//# sourceMappingURL=boardViewApp.tr.js.map